import React from 'react';
import Header from '../Layout/Header';
import './css/parking-allot.css';
import axios from 'axios';
import { useContext, useEffect, useRef, useState } from 'react';
import { dataUser, dataLocation } from './..//Helpers/util';
import { toast } from 'react-toastify';
import { CSVLink } from 'react-csv';
import ParkingReqFilter from './parkingReqFilter';
import ParkingReqSort from './parkingReqSort';
import MarketingPanel from '../MarketingPanel';
import { getServiceAccess } from '../../Redux/action/userActions';
import axiosInstance from '../../utils/axiosInstance';
import mixpanel from 'mixpanel-browser';
import Sidebar from '../Layout/Sidebar';
import { Layout } from "antd";
import CustomHeader from '../Layout/Header';
import SwLoader from '../Common/SwLoader/SwLoader';


const apiURL = require('./../../constant');
const URL_API = apiURL.PROD_URL;
const userDataLocal = dataUser();
var UserObj = JSON.parse(userDataLocal);
const userDataLocal1 = dataLocation();

var LocationObj = JSON.parse(userDataLocal1);
let article = {
company_id: UserObj ? UserObj.company_id : 202,
offset: 0,
limit: 25,
search: '',
location_id: LocationObj
};
let articleCopy = article;

export default function Parking() {
const [ParkingUser, setParkingUser] = useState([]);
const [collapsed, setCollapsed] = useState(true);
const [ParkingCount, setParkingCount] = useState([]);
const [RequestId, setRequestId] = useState(0);
const [RequestText, setRequestText] = useState('');
const [RequestStatus, setRequestStatus] = useState('');
const [TagId, setTagId] = useState('');
const [FilterData, setFilterData] = useState({});
const [SortData, setSortData] = useState('');
const [Row, setRowData] = useState('25');
const [PageNo, setPageNoData] = useState(1);
const [bg, changeBGColor] = useState(0);
const [accessServiceLists, setAccessServiceLists] = useState([]);
const [loaderServiceAccess, setLoaderServiceAccess] = useState(true);
const headers = [
{ label: 'Id', key: 'rec_id' },
{ label: 'Email', key: 'email' },
{ label: 'Phone', key: 'phone' },
{ label: 'Status', key: 'status' },
{ label: 'User Id', key: 'user_id' },
{ label: 'User Name', key: 'user_name' },
{ label: 'Vehicle Number', key: 'vehicle_number' },
{ label: 'Vehicle RC', key: 'vehicle_rc' },
{ label: 'Vehicle Wheelers', key: 'wheeler' },
];

useEffect(() => {
const fetchData = async () => {
try {
// Await the API request for parkplus count
const response = await axiosInstance.post(
`${process.env.REACT_APP_API_GATEWAYS_URL}cspoc/api/v1/parking/parkplus_count`,
article
);
// Set the parking count data from the response
setParkingCount(response.data.data);
} catch (error) {
// Handle any error during the API request
console.error('Error fetching parkplus count:', error);
}
};
fetchData(); // Call the async function
// Cleanup function to prevent state updates after component unmounts
return () => {
// Handle any necessary cleanup here (if needed)
// For example, you could set a flag to avoid updating the state after unmounting

};
}, []);
const toggleCollapsed = () => {
setCollapsed((prevState) => !prevState);
};

useEffect(() => {
const changeStatusData = async () => {
try {
// Assuming you need to change the status
changeListStatus(9);
// Make the API request
const response = await axiosInstance.post(`${process.env.REACT_APP_API_GATEWAYS_URL}cspoc/api/v1/parking/parking_request`, article);
setParkingUser(response.data.data);
// Call setData() if necessary
setData();
} catch (error) {
console.error('Error changing list status:', error);
}
};
changeStatusData(); // Call the async function
// Cleanup function to avoid state updates after the component unmounts
return () => {

// Additional cleanup logic if needed
};
}, []);

const parkingView = () => {
mixpanel.track('Parking View', {
PageName: 'Parking',
UserEmail: UserObj.email,
UserName: UserObj.fname + ' ' + UserObj.lname,
UserId: UserObj.rec_id,
CompanyId: UserObj.company_id,
CompanyName: UserObj.company_name,
Type: 'Parking',
});
}

const changeListStatus = async (type) => {
let authToken = JSON.parse(localStorage.getItem('headData'));
try {
// Change background color based on status type
changeBGColor(type);
// Adjust article status based on type
if (type > 0 && type < 8) {
article.status = type;
} else {
article.status = false;
}
// Await the response from the API call
const response = await axiosInstance.post(`${process.env.REACT_APP_API_GATEWAYS_URL}cspoc/api/v1/parking/parking_request`, article, {
headers: {
Authorization: authToken?.spintlyToken,
},
});
// Set parking user data upon successful response
setParkingUser(response.data.data);
// Optionally, you could call setData() here if needed
// setData();
} catch (error) {
// Log the error if something goes wrong
console.error('Error during the API call:', error);
}
};

const filterListing = async (e) => {
try {
if (e.key === 'Enter') {
// Update the article object with search parameters
article.search = e.target.value;
article.offset = 0;
article.limit = 25;
// Await the first API request for parking requests
const parkingRequestResponse = await axiosInstance.post(`${process.env.REACT_APP_API_GATEWAYS_URL}cspoc/api/v1/parking/parking_request`,
article,
{
}
);
setParkingUser(parkingRequestResponse.data.data);
// Await the second API request for parkplus count
const parkplusCountResponse = await axiosInstance.post(`${process.env.REACT_APP_API_GATEWAYS_URL}cspoc/api/v1/parking/parkplus_count`,
article,
);
setParkingCount(parkplusCountResponse.data.data);
// Call setData() after both requests have completed
setData();
}
} catch (error) {
// Handle errors
console.error('Error during the API calls:', error);
}
};

const fillStatus = async (id, status, tag_id) => {
let alertText = 'Are you sure want to approve this request ?';
if (status == 6) {
alertText = 'Are you sure want to reject this request ?';
} else if (status == 5) {
alertText = 'Are you sure want to delete this request ?';
}
setRequestId(id);
setRequestText(alertText);
setRequestStatus(status);
setTagId(tag_id);
};

const changeStatus = async (id, status, tag_id) => {
let authToken = JSON.parse(localStorage.getItem('headData'));
try {
let dataAry = {
rec_id: id,
status: status,
spoc_name: UserObj.fname + ' ' + UserObj.lname,
comp_name: UserObj.company_name,
tag_id: tag_id,
};
// Await the first API call
const response = await axiosInstance.post(`${process.env.REACT_APP_API_GATEWAYS_URL}cspoc/api/v1/parking/parkplus_status`, dataAry, {
headers: {
Authorization: authToken?.spintlyToken,
}
});
if (response.status === 200) {
// Display success or error toast based on status
if (status === 2) {
toast.success('Request Approved Successfully', {

});
} else if (status === 6) {
toast.error('Request Rejected Successfully', {

});
} else {
toast.error('Request Deleted Successfully', {

});
}
// Update the article status
let articleStatus = article.status;
article.status = false;
// Await the second API call
const parkplusCountResponse = await axiosInstance.post(`${process.env.REACT_APP_API_GATEWAYS_URL}cspoc/api/v1/parking/parkplus_count`, article, {
headers: {
Authorization: authToken?.spintlyToken,
}
});
// Set parking count from the response
setParkingCount(parkplusCountResponse.data.data);
// Change the list status
changeListStatus(articleStatus);
}
} catch (error) {
// Handle any error during the API calls
console.error('Error during the changeStatus API requests:', error);
}
};

const changeListNum = async (num) => {
let authToken = JSON.parse(localStorage.getItem('headData'));
try {
// Update article with the new limit
article.limit = num;
// Await the API request for parking requests
const response = await axiosInstance.post(`${process.env.REACT_APP_API_GATEWAYS_URL}cspoc/api/v1/parking/parking_request`, article, {
headers: {
Authorization: authToken?.spintlyToken,
},
});
// Update the parking user data
setParkingUser(response.data.data);
// Call setData() after the request is completed
setData();
} catch (error) {
// Handle any error that occurs during the API call
console.error('Error during the API request:', error);
}
};

const previousPage = async (num) => {
let authToken = JSON.parse(localStorage.getItem('headData'));
try {
// Set the new offset in the article
article.offset = num;
// Await the API request for parking requests
const response = await axiosInstance.post(`${process.env.REACT_APP_API_GATEWAYS_URL}cspoc/api/v1/parking/parking_request`, article, {
headers: {
Authorization: authToken?.spintlyToken,
},
});
// Set the parking user data from the response
setParkingUser(response.data.data);
// Optionally call setData after the request
setData();
} catch (error) {
// Handle any error that occurs during the API call
console.error('Error during the API request:', error);
}
};

const nextPage = async (num) => {
let authToken = JSON.parse(localStorage.getItem('headData'));
try {
// Set the new offset in the article
article.offset = num;
// Await the API request for parking requests
const response = await axiosInstance.post(`${process.env.REACT_APP_API_GATEWAYS_URL}cspoc/api/v1/parking/parking_request`, article, {
headers: {
Authorization: authToken?.spintlyToken,
},
});
// Set the parking user data from the response
setParkingUser(response.data.data);
// Optionally call setData after the request
setData();
} catch (error) {
// Handle any error that occurs during the API call
console.error('Error during the API request:', error);
}
};

let totalRec = ParkingCount.total;
let ptype = [
'total',
'pending',
'approved',
'assigned',
'deleted',
'deleted_req',
'rejected',
'rejected_sw',
];
if (article.status) {
var typeVar = ptype[article.status];
totalRec = ParkingCount[typeVar];
}

let count = parseInt(article.offset);
//let totalRec = ParkingCount.total;

let totalPage = Math.ceil(totalRec / article.limit);
if (totalRec / article.limit > 0 && totalRec / article.limit < 1)
totalPage = 1;
let nextSet = parseInt(article.limit) + parseInt(count);
let prevSet = count - article.limit;
let pgno = parseInt(nextSet / article.limit);
let lastPage = totalPage - pgno;
let next = parseInt(totalRec - article.limit * pgno);
let forward = 'Disabled';
let backward = 'Disabled';

async function setData() {
count = parseInt(article.offset);
totalRec = ParkingCount.total;

totalPage = Math.ceil(totalRec / article.limit);
if (totalRec / article.limit > 0 && totalRec / article.limit < 1)
totalPage = 1;
nextSet = parseInt(article.limit) + parseInt(count);
prevSet = count - article.limit;
pgno = parseInt(nextSet / article.limit);
next = parseInt(totalRec - article.limit * pgno);
lastPage = totalPage - pgno;
}

if (next > 0) {
forward = '';
}

if (pgno > 1) {
backward = '';
}

// const clearSearchBox = () => {
// // this.setState({ searchText: "" });
// }

const handleLanguage = langValue => {
setFilterData(langValue);
};

const shortSelectData = shortallkey => {
setSortData(shortallkey);
};

useEffect(() => {
fetchServiceAccess();
parkingView();
}, []);

const fetchServiceAccess = async () => {
const getCompanyId = UserObj.company_id;
const response = await getServiceAccess(getCompanyId);
setAccessServiceLists(response);
setLoaderServiceAccess(false);
}

const childCallback = async (value) => {
let authToken = JSON.parse(localStorage.getItem('headData'));
if (value == null) {
article = articleCopy; // Reset article if value is null
} else {
article = {
...article,
...value, // Merge new values with the existing article
};
}
try {
// First API request
const parkingRequestResponse = await axiosInstance.post(`${process.env.REACT_APP_API_GATEWAYS_URL}cspoc/api/v1/parking/parking_request`, article, {
headers: {
Authorization: authToken?.spintlyToken,
},
});
setParkingUser(parkingRequestResponse.data.data);
// Second API request
const parkplusCountResponse = await axiosInstance.post(`${process.env.REACT_APP_API_GATEWAYS_URL}cspoc/api/v1/parking/parkplus_count`, article, {
headers: {
Authorization: authToken?.spintlyToken,
},
});
setParkingCount(parkplusCountResponse.data.data);
} catch (e) {
// Handle any errors during the API calls
console.error('Error during API requests:', e);
}
};

let serviceAccess = true;
const serviceAccessId = 8;
if (accessServiceLists.length > 0) {
let serviceAccessobject = {};
accessServiceLists.map(e => {
if (e.id == serviceAccessId) serviceAccessobject = e;
});
serviceAccess = false;
if (serviceAccessobject)
serviceAccess = serviceAccessobject.service_access;
}

return (
<>
<Layout>
<Sidebar collapsed={collapsed} />

<CustomHeader collapsed={collapsed} toggleCollapsed={toggleCollapsed} />

<Layout className={collapsed ? 'PageLayout CollapsedPageLayout' : 'PageLayout'}>
{serviceAccess === true ?

<>
<div class="shade" />
<div className="PageContent">
<div className="row">
<div class="col-md-6 col-xl-6 col-lg-6 col-xs-12">
<h4 class="seatBooking"> Parking Allotment</h4>
</div>
<div class="col-md-12 col-xl-6 col-lg-6">
<div class="filterFild">
<ul>
<li>
<div>
<div class="formSearch position-relative">
<svg
xmlns="http://www.w3.org/2000/svg"
width="19.295"
height="19.295"
viewBox="0 0 19.295 19.295"
>
<g>
<path
stroke-width="0.25px"
d="M29.812 28.693l-4.579-4.579a8.02 8.02 0 1 0-1.123 1.123l4.579 4.575a.793.793 0 0 0 1.123-1.119zm-10.786-3.238a6.431 6.431 0 1 1 6.433-6.429 6.437 6.437 0 0 1-6.433 6.429z"
transform="translate(.125 .125) translate(-11 -11)"
/>
</g>
</svg>
<input
class="form-control tableSearchInput"
placeholder="Search..."
onKeyPress={filterListing}
/>
</div>
</div>
</li>
<li>
<ParkingReqFilter
clearSearch={''}
sendFilterToParent={childCallback}
/>
</li>
<li>
<ParkingReqSort
parkingInfo={ParkingUser}
sendSortToParent={childCallback}
/>
</li>

<li>
<CSVLink
data={ParkingUser}
headers={headers}
filename={'Parking.csv'}
>
<button type="button" className="btn btn-primary addBtn">
<span>
<img src="img/submenuwhite.svg" />
</span>
Export
</button>
</CSVLink>
</li>
</ul>
</div>
</div>
</div>
<div class="row">
<div class="col-12">
<div class="tableHeaderResponse NewHeadRespData">
<div class="fullsx parkingfullsx-no">
<div
className={
'divFlex' + ' ' + (bg == 9 ? 'selected-filter-tab' : '')
}
data-toggle="tooltip"
data-placement="top"
title=""
data-original-title="Click to view Total Request List"
>
<div className={'tableresBox'}>
<a
href="Javascript:void(0);"
onClick={() => {
changeListStatus(9);
}}
>
<p>Total Request</p>
<h3>{ParkingCount.total}</h3>
</a>
</div>
</div>
<div
className={
'divFlex' + ' ' + (bg == 3 ? 'selected-filter-tab' : '')
}
data-toggle="tooltip"
data-placement="top"
title=""
data-original-title="Click to view Assigned List"
>
<div className={'tableresBox'}>
<a
href="Javascript:void(0);"
onClick={() => {
changeListStatus(3);
}}
>
<p>Assigned by SW</p>

<h3>{ParkingCount.assigned}</h3>
</a>
</div>
</div>
<div
className={
'divFlex' + ' ' + (bg == 1 ? 'selected-filter-tab' : '')
}
data-toggle="tooltip"
data-placement="top"
title=""
data-original-title="Click to view Pending List"
>
<div className={'tableresBox'}>
<a
href="Javascript:void(0);"
onClick={() => {
changeListStatus(1);
}}
>
<p>Pending by me</p>
<h3>{ParkingCount.pending}</h3>
</a>
</div>
</div>
<div
className={
'divFlex' + ' ' + (bg == 2 ? 'selected-filter-tab' : '')
}
data-toggle="tooltip"
data-placement="top"
title=""
data-original-title="Click to view Approved List"
>
<div className={'tableresBox'}>
<a
href="Javascript:void(0);"
onClick={() => {
changeListStatus(2);
}}
>
<p>Approved by me</p>
<h3>{ParkingCount.approved}</h3>
</a>
</div>
</div>
<div
className={
'divFlex' + ' ' + (bg == 6 ? 'selected-filter-tab' : '')
}
data-toggle="tooltip"
data-placement="top"
title=""
data-original-title="Click to view Rejected List"
>
<div className={'tableresBox'}>
<a
href="Javascript:void(0);"
onClick={() => {
changeListStatus(6);
}}
>
<p>Rejected by me</p>
<h3>{ParkingCount.rejected}</h3>
</a>
</div>
</div>
<div
className={
'divFlex' + ' ' + (bg == 4 ? 'selected-filter-tab' : '')
}
data-toggle="tooltip"
data-placement="top"
title=""
data-original-title="Click to view Deleted List"
>
<div className={'tableresBox'}>
<a
href="Javascript:void(0);"
onClick={() => {
changeListStatus(4);
}}
>
<p>Deleted by SW</p>

<h3>{ParkingCount.deleted}</h3>
</a>
</div>
</div>
<div
className={
'divFlex' + ' ' + (bg == 7 ? 'selected-filter-tab' : '')
}
data-toggle="tooltip"
data-placement="top"
title=""
data-original-title="Click to view Rejected Request List"
>
<div className={'tableresBox'}>
<a
href="Javascript:void(0);"
onClick={() => {
changeListStatus(7);
}}
>
<p>Rejected by SW</p>

<h3>{ParkingCount.rejected_sw}</h3>
</a>
</div>
</div>
<div
className={
'divFlex' + ' ' + (bg == 5 ? 'selected-filter-tab' : '')
}
data-toggle="tooltip"
data-placement="top"
title=""
data-original-title="Click to view Delete Request List"
>
<div className={'tableresBox'}>
<a
href="Javascript:void(0);"
onClick={() => {
changeListStatus(5);
}}
>
<p>Delete Request to CM</p>
<h3>{ParkingCount.deleted_req}</h3>
</a>
</div>
</div>
</div>
</div>
</div>
</div>

<div class="row">
<div class="col-12">
<div class="commonTable">
<table class="table customeTable">
<thead>
<tr>
<th>Name</th>
<th>Phone No.</th>
<th>Email</th>
<th>Vehicle Number</th>
<th>Vehicle RC</th>
<th>Vehicle Type</th>
<th>Status</th>
<th>Action</th>
</tr>
</thead>
<tbody>
{ParkingUser != null
? ParkingUser.map((items, i) => (
<tr>
<td>{items.user_name}</td>
<td>{items.phone}</td>
<td>{items.email}</td>
<td>{items.vehicle_number}</td>
<td>
  <button
    onClick={() => {
      if (!items.vehicle_rc) {
        toast.warning("Vehicle RC is not available"); // ✅ Show toast notification
        return;
      }
      window.open(items.vehicle_rc, "_blank", "noopener,noreferrer");
    }}
    className="btn btn-outline-primary btn-sm rc-view"
  >
    View
  </button>
</td>

<td>{items.wheeler} Wheeler</td>
{(() => {
if (
items.status == 'Approved' ||
items.status == 'Assigned'
) {
return (
<td>
<span class="text-success">
{items.status}
</span>
</td>
);
} else if (
items.status == 'Rejected' ||
items.status == 'Delete Request'
) {
return (
<td>
<span class="text-danger">
{items.status}
</span>
</td>
);
} else {
return (
<td>
<span>{items.status}</span>
</td>
);
}
})()}

{(() => {
if (items.status == 'Pending') {
return (
<td>
<a
type="button"
data-toggle="modal"
data-target="#myModal"
class="btn btn-success parking-tbl-action-btn"
onClick={() => {
fillStatus(items.rec_id, 2, 0);
}}
>
Approve
</a>
<a
type="button"
data-toggle="modal"
data-target="#myModal"
class="btn btn-warning parking-tbl-action-btn"
onClick={() => {
fillStatus(items.rec_id, 6, 0);
}}
>
Reject
</a>
</td>
);
} else if (items.status == 'Assigned') {
return (
<td>
<a
type="button"
data-toggle="modal"
data-target="#myModal"
class="btn btn-danger parking-tbl-action-btn"
onClick={() => {
fillStatus(items.rec_id, 5, items.tag_id);
}}
>
Delete
</a>
</td>
);
} else {
return <td />;
}
})()}
</tr>
))
: ''}
</tbody>
</table>
<div class="tableFooter">
<div class="row">
<div class="col-md-12 col-lg-6">
<div class="showEntries">
Showing
<select
class="newSelectOp"
name="num_row"
onChange={e => changeListNum(e.target.value)}
>
<option value="10">10</option>
<option value="25" selected>
25
</option>
<option value="50">50</option>
<option value="100">100</option>
</select>
entries per page
</div>
</div>
<div class="col-md-12 col-lg-6">
<div class="showEntries pull-right">
<p class="pull-left">
Showing<span class="text-info"> {pgno} </span>of &nbsp;
<span class="text-info">{totalPage}</span> &nbsp; Pages
of {totalRec} entries
</p>
<div class="forwordIcon">
<button
class={'backforword btn ' + backward}
onClick={() => {
previousPage(prevSet);
}}
>
<i class="fa fa-angle-left" aria-hidden="true" />
</button>
<button
class={'Nextforword btn ' + forward}
onClick={() => {
nextPage(nextSet);
}}
>
<i class="fa fa-angle-right" aria-hidden="true" />
</button>
<div class="clearfix" />
</div>
</div>
</div>
</div>
</div>
</div>
</div>
</div>
</div>
// {/* </section> */}
{/*<!-- Modal -->*/}
<div
class="modal fade"
id=" viewRCmodal"
tabindex="-1"
aria-labelledby="exampleModalLabel"
aria-hidden="true"
>
<div class="modal-dialog">
<div class="modal-content">
<div class="modal-header">
<h5 class="modal-title" id="exampleModalLabel">
Modal title
</h5>
<button
type="button"
class="close"
data-dismiss="modal"
aria-label="Close"
>
<span aria-hidden="true">&times;</span>
</button>
</div>
<div class="modal-body">...</div>
<div class="modal-footer">
<button
type="button"
class="btn btn-secondary"
data-dismiss="modal"
>
Close
</button>
<button type="button" class="btn btn-primary">
Save changes
</button>
</div>
</div>
</div>
</div>
<div className=" modal fade qrModel" id="myModal">
<div className="modal-dialog ">
<div className="modal-content ">
<div className="formTitle">
Parking Request
<button
type="button"
className="relateDox close"
data-dismiss="modal"
>
x
</button>
</div>
<div className="modal-body">
<div className="qrScannerMain">
<div className="row">
<div className="col-md-12 col-xl-9 col-lg-9">
<p id="modalText">{RequestText}</p>
</div>
</div>
</div>
</div>
<div class="modal-footer">
<button
className="btn btn-success"
data-dismiss="modal"
onClick={() => {
changeStatus(RequestId, RequestStatus, TagId);
}}
>
Yes
</button>
<button className="btn btn-danger" data-dismiss="modal">
Cancel
</button>
</div>
</div>
</div>
</div>
{/* <script src="https://ajax.googleapis.com/ajax/libs/jquery/3.5.1/jquery.min.js"></script>
<script src="https://cdnjs.cloudflare.com/ajax/libs/popper.js/1.16.0/umd/popper.min.js"></script>
<script src="https://maxcdn.bootstrapcdn.com/bootstrap/4.5.2/js/bootstrap.min.js"></script>
<script>
$(".hamburger").click(function(){
$(".leftMenu").addClass("slider");
$(".shade").addClass("slider");
});
$(".selectArea").click(function(){
$(".selectArea").toggleClass("setAnimation");
});
$(".shade").click(function(){
$(".leftMenu").removeClass("slider");
$(".shade").removeClass("slider");
});
</script> */}
</>
: loaderServiceAccess == true ? (

<>

<SwLoader />

</>

) : <MarketingPanel />

}
</Layout>
</Layout>
</>
);
}
